// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__HE5vC","small":"styles_small__3q9Ly","large":"styles_large__3asgP"};